import CustomButton from "components/Atoms/CustomButton"
import StringInput from "components/Atoms/StringInput"
import { withFormController } from "components/Molecules/FormController"
import React from "react"
import { calculateDiscount } from "utils/discount"
import { inr } from "utils/formatters.utils"
import { SelectDiscount } from "./SelectDiscount"
import SellableItemPreview from "./SellableItemPreview"
import StockSelector from "./StockSelector"
import useOrderIds from "./useOrderIds"

type OrderItemProps = {
  index?: number
  path?: any
  source?: any
  data?: any
  onRemove?: any
  distributionCentres?: number[]
  showDiscount?: boolean
  handleChange?: any
  user?: any
  requireUserGroup?: boolean
}

export function getAvailableStock(stock: any, isConsolidated?: boolean) {
  const relatedOfferStock = stock?.relatedStock?.offerStockCount

  // If the order is consolidated show currentStockCount
  return isConsolidated
    ? stock?.currentStockCount
    : relatedOfferStock || stock?.offerStockCount || 0
}
const OrderItem = ({
  distributionCentres,
  user,
  index,
  path,
  source,
  data,
  onRemove,
  showDiscount = false,
  handleChange,
  requireUserGroup = false,
}: OrderItemProps) => {
  const orders = useOrderIds()
  const orderItems = source?.orderItems
  const selectedStock = data?.sellableItemStock
  const selectedRelatedOfferStock = selectedStock?.relatedStock?.offerStockCount

  const sellableItem = selectedStock?.sellableItem || data?.sellableItem
  const isConsolidated = orders?.length > 0
  const quantity = +data?.quantity
  let intent = "none"

  if (quantity) {
    if (orders?.length > 0) {
      if (quantity > selectedStock?.currentStockCount) {
        intent = "danger"
      }
    } else if (
      selectedRelatedOfferStock
        ? quantity > selectedRelatedOfferStock
        : quantity > selectedStock?.offerStockCount
    ) {
      intent = "danger"
    }
  } else {
    intent = "danger"
  }

  const finalStockRate =
    selectedStock?.discountedRate !== undefined && data?.quantity !== undefined
      ? selectedStock?.discountedRate * data?.quantity
      : undefined

  const minAmount = data?.discount?.coupon
    ? JSON.parse(data?.discount?.coupon?.discountConditions)?.min_amount
    : undefined

  const calculatedDiscount = data?.discount?.coupon
    ? calculateDiscount({
        amount: finalStockRate,
        flat: data?.discount?.coupon?.flat,
        percent: data?.discount?.coupon?.percentage,
        min: minAmount || undefined,
      })
    : data?.discount?.discountType === "flat" ||
      data?.discount?.discountType === "percent"
    ? calculateDiscount({
        amount: finalStockRate,
        flat:
          data?.discount?.discountType === "flat"
            ? data?.discount?.value
            : undefined,
        percent:
          data?.discount?.discountType === "percent"
            ? data?.discount?.value
            : undefined,
        min: minAmount || undefined,
      })
    : undefined

  const totalDiscountedRate =
    finalStockRate > calculatedDiscount
      ? finalStockRate - calculatedDiscount
      : finalStockRate

  return (
    <div className={"grid grid-cols-12 gap-2"}>
      <div
        data-testid="sellable-item-dropdown"
        className="flex gap-1 col-span-3"
      >
        <div>{index + 1}</div>
        <SellableItemPreview id={sellableItem?.id} name={sellableItem?.name} />
        <StockSelector
          userGroups={user}
          requireUserGroup={requireUserGroup}
          orderItems={orderItems}
          distributionCentres={distributionCentres}
          sellableItem={sellableItem}
          path={path}
          isConsolidated={isConsolidated}
          className="w-full"
        />
      </div>
      {isConsolidated && <div>{inr(data?.sourceDcRate || 0)}</div>}
      <div>
        <span className="line-through" data-testid="old-rate-text">
          {selectedStock?.unitRate}
        </span>
        <span data-testid="current-rate-text">
          {inr(selectedStock?.discountedRate || 0)}
        </span>
      </div>
      <div className="col-span-2">
        <StringInput
          min={1}
          fill={false}
          type="number"
          big={false}
          path={`${path}.quantity`}
          intent={intent}
          data-testid="quantity-input"
          className="w-fit"
        />
        {isConsolidated && data?.stockCount && data?.stockCount > 0 ? (
          <div className="text-xs vt-warning" data-testid="stock-count-warning">
            Includes {data?.stockCount} DC Stock Count
          </div>
        ) : null}
      </div>
      <div data-testid="total-item-cost-text">
        {inr(selectedStock?.discountedRate * data?.quantity || 0)}
      </div>

      {showDiscount && (
        <>
          <div data-testid="total-item-cost-text">
            {calculatedDiscount !== undefined
              ? inr(calculatedDiscount || 0)
              : "--"}
          </div>
          <div data-testid="total-item-cost-text">
            {totalDiscountedRate !== undefined
              ? inr(totalDiscountedRate || 0)
              : "--"}
          </div>{" "}
        </>
      )}
      <div data-testid="stock-text">
        {getAvailableStock(selectedStock, isConsolidated)} <small>Units</small>
      </div>

      <div className="col-span-2 flex justify-between">
        {showDiscount && (
          <SelectDiscount
            onComplete={data => {
              handleChange?.(`${path}.discount`, { ...data })
            }}
            amount={selectedStock?.discountedRate * data?.quantity || 0}
            sellableItemId={sellableItem?.id}
            discount={data?.discount}
          />
        )}
        <CustomButton
          icon="trash"
          intent="danger"
          minimal
          data-testid="delete-item-button"
          onClick={e => onRemove("orderItems", index)}
          className="h-fit"
        />
      </div>
    </div>
  )
}

export default withFormController(OrderItem)
